import React, {Fragment, useEffect, useRef, useState} from "react";

import LazyLoad from 'react-lazy-load';

import clientconfigwebapp, {getLengt_bk} from "../../clientconfigwebapp";
import {Skeleton} from "@mui/material";
 import {Link} from "react-router-dom";

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import '../assets/css/carousel.css'

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const Slider_Galley_Image = (props) => {


    const [image_src_light_box,setData_image_src_light_box] = useState([]);

    const [toggler, setToggler] = useState(false);




    const options = {
        gallery: '#gallery--responsive-images',
        children: 'a',
        dataSource: [
            // simple image
            {
                src: '',
                width: 1620,
                height: 1080,
                alt: 'test image 1'
            },
            // HTML slide
            // {
            //     html: '<div class="custom-html-slide">This is custom HTML slide. <a href="http://example.com" target="_blank" rel="nofollow">Test Link</a>.</div>'
            // }

        ],
        showHideAnimationType: 'none',
        zoom: true,
        pswpModule: () => import('photoswipe')
    };
    let lightbox = new PhotoSwipeLightbox(options);
    lightbox.init();
    ///lightbox.loadAndOpen(1,options.dataSource)



    const openModal_light_box = (index_image) => {

        var array_Products_Images = [];
        if (getLengt_bk(props.data_slider_list) >= 1) {

            for (let counter_image = 0; counter_image < getLengt_bk(props.data_slider_list); counter_image++) {
                let page_curent_info = {};
                page_curent_info['src'] = props.data_slider_list[counter_image].image_src;
                page_curent_info['width'] = "800"; //800px
                page_curent_info['height'] = "800"; //800px
                page_curent_info['alt'] = '';
                array_Products_Images[counter_image] = page_curent_info;
            }

          //  console.log(props.data_slider_list[1], "ppppppp");

            lightbox.loadAndOpen(parseInt(index_image), array_Products_Images);
          // console.log(array_Products_Images, "array_Products_Images");

        }
    }


    return (


        <Fragment>


            {
                props.data_slider_list && props.data_slider_list.length > 0 ? (


                    <Swiper className='w-100 home-swiper-container'
                            modules={[Pagination]}
                            spaceBetween={50}
                            slidesPerView={1}
                            pagination={{clickable: true}}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}
                            autoplay={true}
                            lazy={true}
                            dir={"rtl"}


                    >

                        {


                            (() => {

                                if (getLengt_bk(props.data_slider_list) >= 1) {


                                    return (


                                        props.data_slider_list.map((item_curent, index) => {

                                            return (
                                                <Fragment>
                                                    <SwiperSlide className='Gallerybk-swiper-slide'>

                                                        <div className='w-100'
                                                             onClick={() => openModal_light_box(index)}>
                                                            <img src={item_curent.image_src} className='Gallerybk-img-swiper'/>
                                                        </div>

                                                    </SwiperSlide>
                                                </Fragment>
                                            );


                                        })

                                    )


                                }

                            })()


                        }

                    </Swiper>
                ) : (

                    <Fragment>
                        <div className={"slider-home-karimian"}>
                            <Skeleton variant="rectangular" style={{
                                "width": "100%",
                                "height": "40vh",
                                "marginTop": "24px",
                                "borderRadius": "12px"
                            }}/>
                        </div>
                    </Fragment>


                )


            }



            <div className="pswp-gallery pswp-gallery--single-column" id="gallery--responsive-images"></div>

        </Fragment>
    );
}

export default Slider_Galley_Image;